import { useContext, useEffect, useRef, useState } from "react"
import { MyContext } from "../../Context/MyProvider";
import ImageLoad from "../ImageLoad";
import secureLocalStorage from "react-secure-storage";
import { Link, useLocation } from "react-router-dom";
import Btn_loader from "../Btn_loader";
import PageLoading from "../PageLoading";
import { useTranslation } from "react-i18next";
const Chat_width_astrologer = () => {

    const { t } = useTranslation();
    const location = useLocation();
    const { BaseUrl, HandleCallApi, formatPrice } = useContext(MyContext);

    const [loading, setLoading] = useState(true);
    const [apiloading, setApiLoading] = useState("");
    const [filterlist, setFilterList] = useState([]);
    const [astrologerlist, setAstrologerList] = useState([]);
    const [isfiltermodel, setIsFilterModel] = useState(false);
    const [selectcategory, setSelectCategory] = useState(() => {
        const stateId = location.state?.category_id;
        return stateId !== undefined && stateId !== null ? stateId : "0";
    });
    const [skilllist, setSkillList] = useState([]);
    const [languagelist, setLanguageList] = useState([]);
    const [selectedsortby, setSelectedSortby] = useState("");
    const [selectedskill, setSelectedSkill] = useState([]);
    const [selectedlanguage, setSelectedLanguage] = useState([]);
    const [selectedgender, setSelectedGender] = useState([]);
    const [isapply, setIsApply] = useState(0);
    const [search, setSearch] = useState("");

    const FilterRef = useRef(false);
    const HomeRef = useRef(false);
    const SkillListRef = useRef(false);
    const LanguageListRef = useRef(false);
    const ModelRef = useRef(false);

    const Currency = secureLocalStorage.getItem("currency");

    const SortByList = [
        { title: "Popularity", value: "Popularity" },
        { title: "Experience: High to Low", value: "exp-hign-low" },
        { title: "Experience: Low to High", value: "exp-low-high" },
        { title: "Orders: High to Low", value: "ord-hign-low" },
        { title: "Orders: Low to High", value: "ord-low-high" },
        { title: "Price: High to Low", value: "pri-hign-low" },
        { title: "Price: Low to High", value: "pri-low-high" },
        { title: "Rating: High to Low", value: "rat-hign-low" },
    ];

    const SearchData = astrologerlist.filter(item =>
        item?.name?.toLowerCase().includes(search?.toLowerCase() || "")
    );

    useEffect(() => {
        handleGEtFilterList();
        HandleGetSkillList();
        HandleGetLanguageList();
    }, []);

    useEffect(() => {
        window.document.body.style.overflow = isfiltermodel ? "hidden" : "auto";
    }, [isfiltermodel]);

    useEffect(() => {
        window.document.body.style.overflow = apiloading === "Category" ? "hidden" : "auto";
    }, [apiloading]);

    useEffect(() => {
        handleFetchHomeData(selectcategory, isapply === 0 ? 1 : 2);
    }, [isapply]);

    useEffect(() => {
        const stateId = location.state?.category_id;
        const targetCategory = stateId !== undefined && stateId !== null ? stateId : "0";
        if (String(selectcategory) !== String(targetCategory)) {
            setSelectCategory(targetCategory);
            HomeRef.current = false;
            handleFetchHomeData(targetCategory, 1);
        }
    }, [location.state]);

    const handleFetchHomeData = async (category_id, index) => {
        if (HomeRef.current) return;
        HomeRef.current = true;

        if (index === 2) {
            handleModelOpenClose(2);
            setApiLoading("Category");
        }

        const Userid = secureLocalStorage.getItem("Userid");
        const ApiData = {
            id: Userid || "0",
            category_id,
            filter: {
                sort_by: isapply !== 0 ? selectedsortby : "Popularity",
                skill: isapply !== 0 ? selectedskill : "",
                language: isapply !== 0 ? selectedlanguage : "",
                gender: isapply !== 0 ? selectedgender : ["Male", "Female", "Other"]
            }
        }

        const Response = await HandleCallApi("Post", "user/home_chat_astrologer", ApiData);
        setAstrologerList(Response.data.user_list);
        const LoadingTime = setTimeout(() => {
            setLoading(false);
        }, 500);
        setApiLoading("");
        setIsFilterModel(false);
        return () => clearTimeout(LoadingTime);
    }

    const handleGEtFilterList = async () => {
        if (FilterRef.current) return;
        FilterRef.current = true;
        const Response = await HandleCallApi("Get", "user/category");
        setFilterList(Response.data.category_list);
    }

    const HandleGetSkillList = async () => {
        if (SkillListRef.current) return;
        SkillListRef.current = true;
        const Response = await HandleCallApi("Get", "user/skill");
        setSkillList(Response.data.skill_list);
    }

    const HandleGetLanguageList = async () => {
        if (LanguageListRef.current) return;
        LanguageListRef.current = true;
        const Response = await HandleCallApi("Post", "user/language_list", { language: "" });
        setLanguageList(Response.data.language_list);
    }

    const HandleSelectData = (id, index) => {

        if (index === 1) {
            if (selectedskill.includes(id)) {
                const FilterSkill = selectedskill.filter(s => s !== id);
                setSelectedSkill(FilterSkill);
            } else {
                setSelectedSkill([...selectedskill, id]);
            }
        }

        if (index === 2) {
            if (selectedlanguage.includes(id)) {
                const FilterLanguage = selectedlanguage.filter(l => l !== id);
                setSelectedLanguage(FilterLanguage);
            } else {
                setSelectedLanguage([...selectedlanguage, id]);
            }
        }

        if (index === 3) {
            if (selectedgender.includes(id)) {
                const FilterGender = selectedgender.filter(l => l !== id);
                setSelectedGender(FilterGender);
            } else {
                setSelectedGender([...selectedgender, id]);
            }
        }
    }

    const handleResetFilter = () => {
        setSelectCategory("0")
        setSelectedSortby("");
        setSelectedSkill([]);
        setSelectedLanguage([]);
        setSelectedGender([]);
        HomeRef.current = false;
        setIsApply(0);
        handleModelOpenClose(2);
        setApiLoading("Category");
    }

    const handleModelOpenClose = (index) => {
        if (index === 1) {
            setIsFilterModel(true);
            setTimeout(() => {
                ModelRef.current?.classList.add("open");
            }, 100);
        } else {
            ModelRef.current.classList.remove("open");
            setTimeout(() => {
                setIsFilterModel(false);
            }, 300);
        }
    };

    return (
        <div className="chat_width_astrologer_page">
            {!loading && <div className="width_container">
                <div className="section_1 shadow-sm">
                    <div className="flex items-center">
                        <div className="bg-[--bgcolor] p-[8px] rounded-s-[5px] -me-[10px] z-[200]">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M21.53 20.47L17.689 16.629C18.973 15.106 19.75 13.143 19.75 11C19.75 6.175 15.825 2.25 11 2.25C6.175 2.25 2.25 6.175 2.25 11C2.25 15.825 6.175 19.75 11 19.75C13.143 19.75 15.106 18.973 16.629 17.689L20.47 21.53C20.616 21.676 20.808 21.75 21 21.75C21.192 21.75 21.384 21.677 21.53 21.53C21.823 21.238 21.823 20.763 21.53 20.47ZM3.75 11C3.75 7.002 7.002 3.75 11 3.75C14.998 3.75 18.25 7.002 18.25 11C18.25 14.998 14.998 18.25 11 18.25C7.002 18.25 3.75 14.998 3.75 11Z" fill="white" />
                            </svg>
                        </div>
                        <div className="w-[400px] max-_768_:w-full flex items-center border border-gray-300 px-[15px] focus-within:border-[--bgcolor] rounded-[5px] z-[150]">
                            <input type="text" value={search} onChange={(e) => setSearch(e.target.value)} className="w-full py-[5px] outline-none" placeholder={t("Search name...")} />
                            {search && <button onClick={() => setSearch("")}>
                                <svg width="22" height="22" className="-me-2 text-[--bgcolor]" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.2" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="currentColor" />
                                    <path d="M13.061 12L15.531 9.53005C15.824 9.23705 15.824 8.76202 15.531 8.46902C15.238 8.17602 14.763 8.17602 14.47 8.46902L12 10.939L9.52999 8.46902C9.23699 8.17602 8.76199 8.17602 8.46899 8.46902C8.17599 8.76202 8.17599 9.23705 8.46899 9.53005L10.939 12L8.46899 14.47C8.17599 14.763 8.17599 15.238 8.46899 15.531C8.61499 15.677 8.80699 15.751 8.99899 15.751C9.19099 15.751 9.38298 15.678 9.52898 15.531L11.999 13.061L14.469 15.531C14.615 15.677 14.807 15.751 14.999 15.751C15.191 15.751 15.383 15.678 15.529 15.531C15.822 15.238 15.822 14.763 15.529 14.47L13.061 12Z" fill="currentColor" />
                                </svg>
                            </button>}
                        </div>
                    </div>

                    <button onClick={() => handleModelOpenClose(1)} className="w-[120px] max-_576_:w-full justify-center flex items-center gap-[10px] bg-[--bgcolor] text-white px-[10px] py-[6px] rounded-[10px]">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3 5H10M10 5C10 6.10457 10.8954 7 12 7C13.1046 7 14 6.10457 14 5M10 5C10 3.89543 10.8954 3 12 3C13.1046 3 14 3.89543 14 5M3 12H12M19 12H21M19 12C19 13.1046 18.1046 14 17 14C15.8954 14 15 13.1046 15 12C15 10.8954 15.8954 10 17 10C18.1046 10 19 10.8954 19 12ZM14 5H21M12 19H21M3 19H5M5 19C5 20.1046 5.89543 21 7 21C8.10457 21 9 20.1046 9 19C9 17.8954 8.10457 17 7 17C5.89543 17 5 17.8954 5 19Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                        </svg>
                        <span className="text-[15px]">{t("Filter")}</span>
                    </button>

                </div>

                <div className="section_2">

                    {apiloading === "Category"
                        ? <div className="h-[600px] flex items-center justify-center">
                            <Btn_loader CustomeStyle={"bg-[--bgcolor]"} />
                        </div>
                        : <div>
                            {SearchData?.length >= 1
                                ? <div className="grid max-_425_:grid-cols-1 max-_768_:grid-cols-2 max-_992_:grid-cols-3 max-_1600_:grid-cols-4 grid-cols-5 gap-6">
                                    {SearchData?.map((item, index) => {
                                        const IsStyle = item.waiting_time == 0;
                                        return <Link to={`/astrologers/${item.id}`} key={index} className="user_box shadow group">
                                            <div className="p-5">
                                                <div className="flex items-start justify-between">
                                                    <div className="w-[80px] h-[80px] relative">
                                                        <ImageLoad url={BaseUrl + item.image} CustomeStyle={"w-full h-full object-cover border rounded-full"} alt={`${item.name} Image`} />
                                                        <div className="absolute right-0 bottom-0 bg-white rounded-full">
                                                            <svg width="24" height="24" className="text-green-600" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path fillRule="evenodd" clipRule="evenodd" d="M20.1219 9.88002L19.681 9.43901C19.4 9.15801 19.2419 8.77601 19.2419 8.37801V7.757C19.2419 6.101 17.9 4.75902 16.244 4.75902H15.623C15.225 4.75902 14.844 4.60102 14.562 4.32002L14.1209 3.87901C12.9499 2.70801 11.0519 2.70801 9.88094 3.87901L9.4399 4.32002C9.1589 4.60102 8.77698 4.75902 8.37898 4.75902H7.75801C6.10201 4.75902 4.75996 6.101 4.75996 7.757V8.37801C4.75996 8.77601 4.602 9.15701 4.321 9.43901L3.87996 9.88002C2.70896 11.051 2.70896 12.949 3.87996 14.12L4.321 14.561C4.602 14.842 4.75996 15.224 4.75996 15.622V16.243C4.75996 17.899 6.10201 19.241 7.75801 19.241H8.37898C8.77698 19.241 9.1579 19.399 9.4399 19.68L9.88094 20.121C11.0519 21.292 12.9499 21.292 14.1209 20.121L14.562 19.68C14.843 19.399 15.225 19.241 15.623 19.241H16.244C17.9 19.241 19.2419 17.899 19.2419 16.243V15.622C19.2419 15.224 19.4 14.843 19.681 14.561L20.1219 14.12C21.2929 12.949 21.2929 11.051 20.1219 9.88002ZM15.53 10.53L11.53 14.53C11.384 14.676 11.192 14.75 11 14.75C10.808 14.75 10.6159 14.677 10.4699 14.53L8.46992 12.53C8.17692 12.237 8.17692 11.762 8.46992 11.469C8.76293 11.176 9.23796 11.176 9.53096 11.469L11.0009 12.939L14.4709 9.46901C14.7639 9.17601 15.2389 9.17601 15.5319 9.46901C15.8229 9.76201 15.823 10.238 15.53 10.53Z" fill="currentColor" />
                                                            </svg>
                                                        </div>
                                                    </div>
                                                    {(item.live_status === 1 && item.waiting_time === 0 && item.buysy_time_per == 0) && <div className="flex items-center gap-[5px] bg-green-100 px-3 py-[2px] rounded-[50px]">
                                                        <span className="size-2 bg-green-500 rounded-full"></span>
                                                        <h1 className="font-bold uppercase text-[11px] text-green-700">{t("Online")}</h1>
                                                    </div>}
                                                    {(item.live_status === 1 && (item.waiting_time !== 0 || item.buysy_time_per != 0)) && <div className="flex items-center gap-[5px] bg-yellow-100 px-3 py-[2px] rounded-[50px]">
                                                        <span className="size-2 bg-yellow-500 rounded-full"></span>
                                                        <h1 className="font-bold uppercase text-[11px] text-yellow-700">{t("Busy")}</h1>
                                                    </div>}
                                                </div>
                                                <div className="mt-4">
                                                    <h1 className="text-lg font-bold text-[#181411] group-hover:text-[--bgcolor] transition-colors">{item.name}</h1>
                                                    <p className="text-[#897561] text-sm font-medium trime">{item.skills}</p>
                                                    <p className="text-[#897561] text-[13px] mb-3">{item.lang}</p>
                                                    <div className="flex items-center gap-4 mb-4">
                                                        <div className="flex flex-col">
                                                            <span className="text-xs text-[#897561] uppercase font-bold tracking-tighter">{t("Exp")}</span>
                                                            <span className="text-sm font-bold">{item.experience} {t("yrs")}</span>
                                                        </div>
                                                        <div className="w-px h-6 bg-[#c2c2c2]"></div>
                                                        <div className="flex flex-col">
                                                            <div className="flex items-center gap-0.5 text-primary">
                                                                <svg width="17" height="17" className="text-yellow-600" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M12.962 4.59601L14.904 8.513C15.05 8.808 15.332 9.01202 15.659 9.05902L20.1419 9.70697C20.9639 9.82597 21.292 10.834 20.697 11.412L17.456 14.557C17.219 14.787 17.111 15.118 17.167 15.443L17.9079 19.747C18.0579 20.62 17.1409 21.286 16.3549 20.875L12.467 18.84C12.175 18.687 11.827 18.687 11.536 18.84L7.65096 20.873C6.86396 21.285 5.94393 20.618 6.09493 19.743L6.83602 15.443C6.89202 15.118 6.78396 14.787 6.54696 14.557L3.30599 11.412C2.70999 10.834 3.03792 9.82597 3.86092 9.70697L8.34395 9.05902C8.66995 9.01202 8.95196 8.808 9.09896 8.513L11.041 4.59601C11.432 3.80101 12.568 3.80101 12.962 4.59601Z" fill="currentColor" />
                                                                </svg>
                                                                <span className="text-sm font-bold text-[#181411]">{item.rating_astro}</span>
                                                                <span className="text-sm text-gray-600">({item.rating}  {t("Reviews")})</span>
                                                            </div>
                                                            <span className="text-[10px] text-[#897561] dark:text-[#a08d7c] uppercase font-bold">{item.torder} {t("orders")}</span>
                                                        </div>
                                                    </div>
                                                    <div className="flex items-baseline gap-2">
                                                        <span className="text-xl font-bold text-red-600 leading-none">{formatPrice(item.off_price)}/{t("min")}</span>
                                                        <span className="text-sm text-[#897561] dark:text-[#a08d7c] line-through">{formatPrice(item.base_price)}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            {(item.waiting_time === 0 && item.buysy_time_per == "0") && <button className="w-full bg-green-600 flex items-center justify-center gap-[10px] text-[16px] text-white font-bold py-[10px] hover:bg-green-700 transition-colors">
                                                <svg width="20" height="20" className="text-white" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 14H16M8 10H12M21.9664 11.2166C21.9886 11.4748 22 11.7361 22 12C22 16.9706 17.9706 21 13 21H6C3.79086 21 2 19.2091 2 17V12C2 7.02944 6.02944 3 11 3H13C13.2639 3 13.5252 3.01136 13.7834 3.03362M22 6C22 7.65685 20.6569 9 19 9C17.3431 9 16 7.65685 16 6C16 4.34315 17.3431 3 19 3C20.6569 3 22 4.34315 22 6Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"></path></svg>
                                                {t("Chat Now")}
                                            </button>}
                                            {(item.waiting_time !== 0 || item.buysy_time_per != 0) && <button className={`w-full border-t flex items-center justify-center gap-[10px] text-[16px] font-bold py-[9px] ${IsStyle ? "border-orange-200 bg-orange-50 text-[--bgcolor]" : "border-red-200 bg-red-50 text-red-600"}`}>
                                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M12 1.25C6.072 1.25 1.25 6.072 1.25 12C1.25 17.928 6.072 22.75 12 22.75C17.928 22.75 22.75 17.928 22.75 12C22.75 6.072 17.928 1.25 12 1.25ZM12 21.25C6.899 21.25 2.75 17.101 2.75 12C2.75 6.899 6.899 2.75 12 2.75C17.101 2.75 21.25 6.899 21.25 12C21.25 17.101 17.101 21.25 12 21.25ZM15.53 14.47C15.823 14.763 15.823 15.238 15.53 15.531C15.384 15.677 15.192 15.751 15 15.751C14.808 15.751 14.616 15.678 14.47 15.531L11.47 12.531C11.329 12.39 11.25 12.199 11.25 12.001V7.00098C11.25 6.58698 11.586 6.25098 12 6.25098C12.414 6.25098 12.75 6.58698 12.75 7.00098V11.6899L15.53 14.47Z" fill="currentColor" />
                                                </svg>
                                                {t("Wait")} ~ {item.waiting_time == 0 ? item.buysy_time_per : `${Math.round(item.waiting_time)}m`}
                                            </button>}
                                        </Link>
                                    })}
                                </div>
                                : <div className="h-[500px] flex items-center justify-center">
                                    <h1 className="font-bold text-[20px] text-gray-600">{t("There are no astrologers in this category.")}</h1>
                                </div>}
                        </div>}
                </div>
            </div>}

            {isfiltermodel && <div ref={ModelRef} className="filter_area">

                <div className="flex items-center justify-between gap-[10px] border-b border-gray-100 py-[20px] bg-white">
                    <h1 className="font-bold text-[24px] text-gray-800">{t("Sort")} &amp; {t("Filter")}</h1>
                    <button onClick={() => handleModelOpenClose(2)} className="p-2 hover:bg-gray-100 rounded-full transition-all duration-200 text-gray-500 hover:text-gray-800">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>
                </div>

                <div className="flex-1 overflow-y-auto pr-[5px] scroll_container">
                    <div className="pb-[20px] pt-[15px] border-b border-gray-100">
                        <h1 className="font-semibold text-lg text-gray-800 mb-3">{t("Category")}</h1>
                        <div className="flex flex-wrap items-center gap-[10px]">
                            <div onClick={() => setSelectCategory("0")} 
                                 className={`border-[1.5px] px-[16px] py-[6px] rounded-[50px] cursor-pointer transition-all duration-200 ${
                                     String(selectcategory) === "0" 
                                     ? "border-[--bgcolor] bg-orange-50/60 text-[--bgcolor] font-medium shadow-sm shadow-orange-100" 
                                     : "border-gray-200 text-gray-600 bg-white hover:border-gray-300 hover:bg-gray-50/50"
                                 }`}>
                                <div className="flex items-center gap-[6px]">
                                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3 5H10M10 5C10 6.10457 10.8954 7 12 7C13.1046 7 14 6.10457 14 5M10 5C10 3.89543 10.8954 3 12 3C13.1046 3 14 3.89543 14 5M3 12H12M19 12H21M19 12C19 13.1046 18.1046 14 17 14C15.8954 14 15 13.1046 15 12C15 10.8954 15.8954 10 17 10C18.1046 10 19 10.8954 19 12ZM14 5H21M12 19H21M3 19H5M5 19C5 20.1046 5.89543 21 7 21C8.10457 21 9 20.1046 9 19C9 17.8954 8.10457 17 7 17C5.89543 17 5 17.8954 5 19Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                                    </svg>
                                    <h1 className="text-[14px]">{t("All")}</h1>
                                </div>
                            </div>
                            {filterlist.map((item, index) => {
                                const IsSelected = String(item.id) === String(selectcategory)
                                return <div key={index} onClick={() => setSelectCategory(item.id)} 
                                            className={`border-[1.5px] px-[16px] py-[4px] rounded-[50px] cursor-pointer transition-all duration-200 ${
                                                IsSelected 
                                                ? "border-[--bgcolor] bg-orange-50/60 text-[--bgcolor] font-medium shadow-sm shadow-orange-100" 
                                                : "border-gray-200 text-gray-600 bg-white hover:border-gray-300 hover:bg-gray-50/50"
                                            }`}>
                                    <div className="flex items-center gap-[6px]">
                                        <ImageLoad url={BaseUrl + item?.logo} CustomeStyle={`w-[20px] h-[20px] object-contain ${IsSelected ? "brightness-100 contrast-120" : "opacity-80"}`} alt={"Category img"} />
                                        <h1 className="text-[14px]">{item.title}</h1>
                                    </div>
                                </div>
                            })}
                        </div>
                    </div>

                    <div className="pb-[20px] pt-[15px] border-b border-gray-100">
                        <h1 className="font-semibold text-lg text-gray-800 mb-3">{t("Sort by")}</h1>
                        <div className="flex flex-wrap items-center gap-[10px]">
                            {SortByList.map((item, index) => {
                                const IsSelected = item.value === selectedsortby;
                                return <div key={index} onClick={() => setSelectedSortby(item.value)} 
                                            className={`border-[1.5px] px-[16px] py-[6px] rounded-[50px] cursor-pointer transition-all duration-200 ${
                                                IsSelected 
                                                ? "bg-[--bgcolor] text-white border-[--bgcolor] font-medium shadow-sm shadow-orange-100" 
                                                : "border-gray-200 text-gray-600 bg-white hover:border-gray-300 hover:bg-gray-50/50"
                                            }`}>
                                    <h1 className="text-[14px]">{t(item.title)}</h1>
                                </div>
                            })}
                        </div>
                    </div>

                    <div className="pb-[20px] pt-[15px] border-b border-gray-100">
                        <h1 className="font-semibold text-lg text-gray-800 mb-3">{t("Skill")}</h1>
                        <div className="flex flex-wrap items-center gap-[10px]">
                            {skilllist.map((item, index) => {
                                const IsSelected = selectedskill.includes(item.id);
                                return <div key={index} onClick={() => HandleSelectData(item.id, 1)} 
                                            className={`border-[1.5px] px-[16px] py-[6px] rounded-[50px] cursor-pointer transition-all duration-200 ${
                                                IsSelected 
                                                ? "bg-[--bgcolor] text-white border-[--bgcolor] font-medium shadow-sm shadow-orange-100" 
                                                : "border-gray-200 text-gray-600 bg-white hover:border-gray-300 hover:bg-gray-50/50"
                                            }`}>
                                    <h1 className="text-[14px]">{item.title}</h1>
                                </div>
                            })}
                        </div>
                    </div>

                    <div className="pb-[20px] pt-[15px] border-b border-gray-100">
                        <h1 className="font-semibold text-lg text-gray-800 mb-3">{t("Gender")}</h1>
                        <div className="flex flex-wrap items-center gap-[10px]">
                            {["Male", "Female", "Other"].map((item, index) => {
                                const IsSelected = selectedgender.includes(item);
                                return <div key={index} onClick={() => HandleSelectData(item, 3)} 
                                            className={`border-[1.5px] px-[16px] py-[6px] rounded-[50px] cursor-pointer transition-all duration-200 ${
                                                IsSelected 
                                                ? "bg-[--bgcolor] text-white border-[--bgcolor] font-medium shadow-sm shadow-orange-100" 
                                                : "border-gray-200 text-gray-600 bg-white hover:border-gray-300 hover:bg-gray-50/50"
                                            }`}>
                                    <h1 className="text-[14px]">{item}</h1>
                                </div>
                            })}
                        </div>
                    </div>

                    <div className="pb-[20px] pt-[15px]">
                        <h1 className="font-semibold text-lg text-gray-800 mb-3">{t("Language")}</h1>
                        <div className="flex flex-wrap items-center gap-[10px]">
                            {languagelist.map((item, index) => {
                                const IsSelected = selectedlanguage.includes(item.id);
                                return <div key={index} onClick={() => HandleSelectData(item.id, 2)} 
                                            className={`border-[1.5px] px-[16px] py-[6px] rounded-[50px] cursor-pointer transition-all duration-200 ${
                                                IsSelected 
                                                ? "bg-[--bgcolor] text-white border-[--bgcolor] font-medium shadow-sm shadow-orange-100" 
                                                : "border-gray-200 text-gray-600 bg-white hover:border-gray-300 hover:bg-gray-50/50"
                                            }`}>
                                    <h1 className="text-[14px]">{item.title}</h1>
                                </div>
                            })}
                        </div>
                    </div>
                </div>

                <div className="flex items-center gap-[16px] py-[15px] border-t border-gray-100 mt-auto bg-white">
                    <button onClick={handleResetFilter} className="w-full h-[46px] border border-orange-200 bg-orange-50/70 hover:bg-orange-100/80 active:scale-[0.98] text-[--bgcolor] font-semibold rounded-[12px] transition-all duration-200 flex items-center justify-center">{t("Reset")}</button>
                    <button onClick={() => { HomeRef.current = false; setIsApply((prev) => prev + 1); }} className="w-full h-[46px] bg-[--bgcolor] hover:bg-opacity-90 active:scale-[0.98] text-white font-semibold rounded-[12px] shadow-md shadow-orange-100 transition-all duration-200 flex items-center justify-center">{t("Apply")}</button>
                </div>

            </div>}

            {isfiltermodel && <div onClick={() => handleModelOpenClose(2)} className="fixed top-0 left-0 right-0 bottom-0 bg-[#00000040] z-[8888]"></div>}

            <PageLoading loading={loading} />

        </div >
    )
}
export default Chat_width_astrologer